import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { UserEmailAlertPreferences } from '../../Models/Domains/Threads/UserEmailAlertPreferences';
import { BaseUserEmailAlertPreferences } from '../../Models/Domains/Threads/BaseUserEmailAlertPreferences';

declare var IS_RUNNING_IN_APP_POOL;

export class EmailNotificationPreferencesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<UserEmailAlertPreferences>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/EmailNotificationPreferences/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<UserEmailAlertPreferences>, any>(url, data);
  }
  public put(userEmailAlertPreferencesList: Array<BaseUserEmailAlertPreferences>): Promise<Array<UserEmailAlertPreferences>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/EmailNotificationPreferences/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { userEmailAlertPreferencesList: userEmailAlertPreferencesList }

    return AjaxWrapper.put<Array<UserEmailAlertPreferences>, any>(url, data);
  }
}

